import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Contact from "../pages/contact/page";
import HeatPumps from "../pages/heat-pumps/page";
import Heating from "../pages/heating/page";
import Cooling from "../pages/cooling/page";
import Gallery from "../pages/gallery/page"; // <-- 1. Import your new page

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/heat-pumps",
    element: <HeatPumps />,
  },
  {
    path: "/heating",
    element: <Heating />,
  },
  {
    path: "/cooling",
    element: <Cooling />,
  },
  {
    path: "/gallery", // <-- 2. Add the route path
    element: <Gallery />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;